import { ParallaxItem } from "../../../../components/Parallax/ParallaxContainer.types"


export const FreeSpinsMobParallax: ParallaxItem[] = [
  { image: 'misc.coinAngle12', speed: -3 },
  { image: 'misc.coinAngle11', speed: -7 },
  { image: 'misc.coinAngle9', speed: -4 },
]

export const FreeSpinsDeskParallax: ParallaxItem[] = [
  { image: 'misc.coinAngle4', speed: -18 },
  { image: 'misc.coinAngle18', speed: -16 },
  { image: 'misc.coinAngle17', speed: -22 },
  { image: 'misc.coinAngle7', speed: -18 },
  { image: 'misc.coinAngle11', speed: -20 },
  { image: 'misc.coinAngle18', speed: -18 },
  { image: 'misc.coinAngle7', speed: -18 },
  { image: 'misc.coinAngle4', speed: -22 },
  { image: 'misc.coinAngle2', speed: -20 },
]
